export const FIND_PAYMENT = 'PAYMENTS/find_payment';
export const UPDATE_TXN = 'PAYMENTS/update_txn';
export const TAG_FOR_POSTING = 'PAYMENTS/tag_for_posting';
export const VIEW_PAYMENT_LOGS = 'PAYMENTS/view_payment_logs';
export const VIEW_PAYMENT_LOGS_FOR_TXNID =
  'PAYMENTS/view_payment_logs_for_txnid';
export const POST_PAYMENT_TO_QPAX = 'PAYMENTS/post_payment_to_qpax';
export const MANUAL_EXPIRE_REFNO = 'PAYMENTS/manual_expire_refno';
export const APPROVE_REFUND = 'PAYMENTS/approve_refund';
export const VIEW_PAYMENT_LOGS_FOR_AMOUNT =
  'PAYMENTS/view_payment_logs_for_amount';
export const UPDATE_AMOUNT = 'PAYMENTS/update_amount';
export const REASSESS = 'PAYMENTS/reassess';
